import React, { useState } from "react";
import { BrowserRouter, Route, Link } from "react-router-dom";

function Navbar3() {

  const [teetimeVisible, setTeeTimeVisible] = useState(false);

  const playClick = () => {
    setTeeTimeVisible(!teetimeVisible);
    console.log(teetimeVisible);
  }

    const PlayMenu = () => {
    return(
      <div>
        <ul>
          <li>
            <a class="coursesNav" href="/bluffton/play">Daily Play</a>
          </li>
          <li>
            <a class="coursesNav" href="/bluffton/stay&play">Stay & Play</a>
          </li>
        </ul>
      </div>
    )
  }

  return (
    <nav class="blufftonNav">
      <ul>
        <li>
          <a href="/bluffton">
            <div class="blufftonNavLogo"></div>
          </a>
        </li>
        <li class="coursesLi">
            <div class="dropdownMenu blufftonDropdown">
                <a onClick={playClick}>Play</a>
                {teetimeVisible && <PlayMenu />}
            </div>
        </li>
        <li>
            <a href="/bluffton/courses">Courses</a>
        </li>
        <li>
          <a href="/bluffton/reviews">
            Reviews
          </a>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar3;